// extracted by mini-css-extract-plugin
export default {"left":"Others_left__TXoEe","right":"Others_right__L-vxm","container":"Others_container__CmgVl"};